
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1',
		enableSeo: false
	},
};

const shopMetafields = {
	hexCodes: boostPFSThemeConfig.custom.shop_metafields.hex_codes,
	colourNames: boostPFSThemeConfig.custom.shop_metafields.colour_names,
	swatchImages: boostPFSThemeConfig.custom.shop_metafields.swatch_images,
	brandNames: boostPFSThemeConfig.custom.shop_metafields.brand_names
};

(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;

		var itemHtml;
		if (document.getElementById('plp-promo-block')) {
			const block = document.getElementById('plp-promo-block')
			const position = parseInt(block.getAttribute('data-position'))

			if ((index + 1) == position) {
				itemHtml += block.outerHTML.replace('hidden="true"', '')
			}
		}

		// Get Template
		itemHtml += boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

		//Add class
		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row);

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images, index));

		// Add wishlist
		var wishlistHtml = '<a class="iWishAddColl" aria-label="Add to wishlist" href="#" data-variant="' + data.variants[0].id + '" data-product="' + data.id + '" data-ptitle="' + data.title + '">' +
			'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 76.3 68.6" style="enable-background:new 0 0 76.3 68.6;" xml:space="preserve" class="Icon Icon--account"><style type="text/css">.Header--withIcons:not(.Header--transparent) .st0{    transition: all 0.2s ease-in-out;fill:#000;}</style><g><g><path class="st0" d="M38.2,67.8c-1.7,0-3.3-0.6-4.6-1.7c-2.7-2.3-5.3-4.5-7.6-6.5C18.8,53.4,12.7,48.2,8.4,43c-5.1-6.2-7.5-12.1-7.5-18.6c0-6.4,2.2-12.3,6.2-16.7c4.1-4.5,9.8-6.9,15.9-6.9c4.6,0,8.9,1.5,12.6,4.3c0.9,0.7,1.7,1.4,2.5,2.3c0.8-0.8,1.7-1.6,2.5-2.3c3.7-2.9,8-4.3,12.6-4.3c6.1,0,11.8,2.5,15.9,6.9l0,0c4,4.4,6.2,10.3,6.2,16.7c0,6.5-2.4,12.4-7.5,18.6c-4.3,5.2-10.4,10.4-17.4,16.4l-0.3,0.2c-2.3,2-4.9,4.1-7.5,6.5C41.5,67.2,39.9,67.8,38.2,67.8z M23,6.7c-4.5,0-8.6,1.8-11.5,5c-3,3.3-4.7,7.7-4.7,12.6c0,5.1,1.9,9.8,6.1,14.8c4,4.8,9.9,9.8,16.7,15.6c2.5,2.2,5.1,4.4,7.8,6.7c0.4,0.3,1,0.3,1.4,0c2.7-2.4,5.3-4.6,7.6-6.5l0.3-0.2C53.5,49,59.4,44,63.4,39.2c4.2-5,6.1-9.7,6.1-14.8c0-4.9-1.7-9.4-4.7-12.6c-3-3.2-7.1-5-11.5-5c-3.3,0-6.3,1-9,3.1c-1.4,1.1-2.6,2.4-3.8,3.9l-2.4,3.3l-2.4-3.3c-1.1-1.5-2.4-2.9-3.8-3.9C29.3,7.8,26.3,6.7,23,6.7z"></path></g></g></svg>' +
			'</a>';
		itemHtml = itemHtml.replace(/{{itemWishlist}}/g, wishlistHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}

		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images, index) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0) {
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '">';

			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';

			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}

			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;


			if(index > 3){
				htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			}else{
				htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '200x') + '" srcset="' + Utils.optimizeImage(images[0]['src'], '200x') + ' 200w, ' + Utils.optimizeImage(images[0]['src'], '400x') + ' 400w, ' + Utils.optimizeImage(images[0]['src'], '600x') + ' 600w, ' + Utils.optimizeImage(images[0]['src'], '700x') + ' 700w, ' + Utils.optimizeImage(images[0]['src'], '800x') + ' 800w, ' + Utils.optimizeImage(images[0]['src'], '900x') + ' 900w, ' + Utils.optimizeImage(images[0]['src'], '1000x') + ' 1000w, ' + Utils.optimizeImage(images[0]['src'], '1200x') + ' 1200w" sizes="100vw" fetchpriority="high" loading="eager" alt="' + data.title + '">';
			}


			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';
			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}

			if (supported_sizes == '') supported_sizes = image.width;

			if (!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
		if (onSale) {
			html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
			html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
		} else {
			if (priceVaries) {
				let classToAdd = ''
				if (data.compare_at_price_max > 0) {
					var fromLabel = boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)).replace(/{{max_compare_at_price}}/g, Utils.formatMoney(data.compare_at_price_max));
					classToAdd = 'price--from-sale'
				} else {
					var fromLabel = boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)).replace(/{{max_compare_at_price}}/g, '');
				}
				html += '<span class="ProductItem__Price Price Text--subdued ' + classToAdd + '">' + fromLabel + '</span>';
			} else {
				html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		html += '</div>';
		return html;
	}

	function buildCustomMessage(data) {
		var html = '';

		if (Utils.getProductMetafield(data, 'offer', 'text') != null) {
			html = '<div class="ProductItem__CustomMessage">' +
				'<p class="Price--highlight" style="color: #f94c43;">' + Utils.getProductMetafield(data, 'offer', 'text') + '</p>' +
				'</div>';
		} else if (data.compare_at_price_min) {

			var discountPrice = (data.price_min - data.compare_at_price_min) / data.compare_at_price_min * 100 * -1;
			discountPrice = Math.round(discountPrice) + '%';
			html = '<div class="ProductItem__CustomMessage">' +
				'<p class="Price--highlight" style="color:#f94c43;">' + 'save ' + discountPrice + '</p>' +
				'</div>';
		}

		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if (tag.indexOf('__label') != -1) {
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
					break;
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
			} else {
				product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}

			if (product_labels != '') {
				html += '<div class="ProductItem__LabelList">';
				html += product_labels;
				html += '</div>';
			}
		}
		return html;
	}

	function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="ProductItem__Info ' + infoClass + ' ">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
			}

			html += '<h3 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + data.title + '</a>';
			html += '</h3>';
			html += '{{itemReviews}}';
			html += buildPrice(data);
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx);
			}
			html += buildCustomMessage(data);
			html += '</div>';
		}

		return html;
	}

	function buildSwatch(data) {
		let swatchesHtml = '';
		let oneColour = false;
		let showMore = false;
		const hexCodes = shopMetafields.hexCodes;
		const swatchImages = shopMetafields.swatchImages;
		const colourNames = shopMetafields.colourNames;
		const brandNames = shopMetafields.brandNames;
		const productBrandName = data.vendor.toLowerCase();
		const colorLabel = ['color', 'colour', 'couleur', 'colore', 'farbe', '색', '色', 'färg', 'farve'];

		data.options_with_values.forEach((option, index) => {
			const lowercaseOption = option.name.toLowerCase();

			if (colorLabel.includes(lowercaseOption)) {
				const i = index + 1;
				const variantOption = `option${i}`;
				let count= 0;

				option.values.forEach((value) => {
					const valueTitle = value.title;
					let variantHtml = '';
					let variantForValue = '';
					let variantImageUrl = '';
					let hexValue = '';
					let swatchImage = '';
					let lowercaseValueTitle = valueTitle.toLowerCase();

					if (count < 5) {
						if (option.values.length > 1) {
							oneColour = true;
						}

						colourNames.forEach((name, index) => {
							if (hexValue && swatchImage) return;

							const lowerCaseName = name.toLowerCase();
							const lowerCaseBrandName = brandNames[index].toLowerCase();
							
							if (lowercaseValueTitle === lowerCaseName && productBrandName === lowerCaseBrandName) {
								hexValue = hexCodes[index];
								swatchImage = swatchImages[index][0];
							}
						});
						
						data.variants.forEach((variant) => {
							if (variantForValue) return;

							if (variant[variantOption] === valueTitle) {
								variantForValue = variant;
							}
						});

						if (variantForValue && variantForValue.image) {
							variantImageUrl = Utils.optimizeImage(variantForValue.image);
						}

						const colorSwatchImage = valueTitle ? `${Utils.slugify(valueTitle)}.png` : '';
						const vendorName = `${data.id}-`;
						let backgroundImage = '';

						if (swatchImage && swatchImage.cloudinary_src) {
							backgroundImage = `${swatchImage.cloudinary_src}w_60,h_60`;
						} else if (colorSwatchImage && !hexValue) {
							const assetUrlParts = boostPFSThemeConfig.custom.asset_url.split('[asset]');
							backgroundImage = `${assetUrlParts[0]}${vendorName}${colorSwatchImage}${assetUrlParts[1]}`;
						}

						if (backgroundImage || hexValue) {
							variantHtml += `
								<div class="ProductItem__ColorSwatchItem">
									<input
									class="ColorSwatch__Radio"
									type="radio"
									data-variant-id="${variantForValue.id}"
									data-variant-price="${variantForValue.price ? variantForValue.price : 0}"
									data-variant-compare-at-price="${variantForValue.compare_at_price ? variantForValue.compare_at_price : 0}"
									name="swatch${data.id}"
									id="swatch${variantForValue.id}"
									value="${valueTitle}"
									data-variant-url="${Utils.buildProductItemUrl(data)}?variant=${variantForValue.id}"
								`;
	
								if (variantForValue.image) {
									variantHtml += `
										data-image-id="${variantForValue.id}"
										data-image-url="${variantForValue.image}"
									`;
								}
								
								variantHtml += `
									aria-hidden="true"
									>
												
									<label
										class="js-color-swatch-label ColorSwatch ColorSwatch--small ${lowercaseValueTitle === 'white' ? 'ColorSwatch--white' : ''}"
										for="swatch${variantForValue.id}"
										style="background-color: ${hexValue}"
										title="${valueTitle}"
										data-tooltip="${valueTitle}"
										data-label-bg-image="${backgroundImage ? backgroundImage : ''}"
									>
									</label>
								</div>
							`;
	
							count++;
						}
					}

					if (count === 5) {
						if (showMore) return;

						variantHtml += `
							<div class="ProductItem__ColorSwatchItem">
								<a href="${Utils.buildProductItemUrl(data)}">
								<label class="ColorSwatch ColorSwatch--small" style="background-color: transparent;line-height: 15px;" data-tooltip="More">+</label>
								</a>
							</div>
						`;

						showMore = true;
					}

					swatchesHtml += variantHtml;
				});
			}
		});

		if (swatchesHtml && oneColour) {
			return `
				<div class="ProductItem__ColorSwatchList js-product-card-swatches" style="display:none;">
					${swatchesHtml}
				</div>
			`;
		}

		return '';
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').click(function (e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
			window.scrollTo(0, 0);
		});
	}
	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		/**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function() {
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');

			if (variantInfo.length > 0) {
				productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
				productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
				productImage.find('img.ProductItem__Image').hide();
				productImage.attr('href', variantInfo.data('variant-url'));
				var variantPrice = '';
				if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
					variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
					variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
				} else {
					variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
				}
				jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
			}
		})

		const productCardSwatches = document.querySelectorAll('.js-product-card-swatches');

		productCardSwatches.forEach((swatch) => {
			const colorSwatchLabels = swatch.querySelectorAll('.js-color-swatch-label');

			colorSwatchLabels.forEach((label) => {
				const labelBgImage = label.getAttribute('data-label-bg-image');

				if (label.style.backgroundColor !== '') return;

				if (label.style.backgroundColor === '' && labelBgImage === '') {
					swatch.remove();
				}

				const image = new Image();

				image.addEventListener('error', () => {
					swatch.remove();
				});

				image.addEventListener('load', () => {
					label.style.backgroundImage = `url(${labelBgImage})`;
				});

				image.src = labelBgImage;
			});

			swatch.style.display = 'block';
		});

		//Change view layout
		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
		}
	};

	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		jQ('.boost-pfs-filter-show-result').attr('data-action', 'close-drawer').attr('data-drawer-id', 'collection-filter-drawer').html('Show ' + data.total_product + ' Products');
		var showing_string;
		if (data.products.length > 0) {
			showing_string = boostPFSThemeConfig.label.showing + ' <span>' + data.products.length + '</span> ' + boostPFSThemeConfig.label.of + ' ' + data.total_product;
		}

		jQ('.boost-pfs-filter-total-product').html(showing_string);
	}

	FilterOptionItem.prototype.onClick = function (event) {
		if (event) {
			event.preventDefault();
		}

		window.scrollTo(0, 0);

		if (!this.isDisabled()) {
			if (this.requestInstantly || this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
				this.onApplyFilter();
			} else {
				this.onSelectFilter();
			}
		}
	}

	// Build additional elements
	FilterResult.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
	};

	// Build Default layout
	Filter.prototype.errorFilterCallback = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };
})();

jQ(document).ready(function () {
	jQ('body').on('click', '[data-action="select-filter-item"]', function () {
		window.scrollTo(0, 0);
	});
});
